import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "title flex text-left"
}
const _hoisted_4 = {
  key: 1,
  class: "title flex text-left"
}
const _hoisted_5 = { class: "p-fluid grid mt-2" }
const _hoisted_6 = { class: "field col-12 md:col-6" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { class: "form-label text-left" }
const _hoisted_9 = { class: "field col-12 md:col-6" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = { class: "form-label text-left" }
const _hoisted_12 = { class: "field col-12 md:col-6" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = { class: "p-fluid grid mt-2" }
const _hoisted_16 = { class: "field col-12 lg:col-4" }
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = { for: "salutation" }
const _hoisted_19 = { class: "field col-12 lg:col-4" }
const _hoisted_20 = { class: "p-float-label" }
const _hoisted_21 = { class: "form-label" }
const _hoisted_22 = { class: "field col-12 lg:col-4" }
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = { class: "form-label" }
const _hoisted_25 = { class: "field col-12 md:col-5" }
const _hoisted_26 = { class: "p-float-label" }
const _hoisted_27 = { class: "form-label" }
const _hoisted_28 = { class: "field col-12 md:col-2" }
const _hoisted_29 = { class: "p-float-label" }
const _hoisted_30 = { class: "form-label" }
const _hoisted_31 = { class: "field col-12 md:col-5" }
const _hoisted_32 = { class: "p-float-label" }
const _hoisted_33 = { class: "form-label" }
const _hoisted_34 = { class: "field col-12 md:col-6" }
const _hoisted_35 = { class: "p-float-label" }
const _hoisted_36 = { class: "form-label" }
const _hoisted_37 = { class: "field col-12 md:col-6" }
const _hoisted_38 = { class: "p-float-label" }
const _hoisted_39 = { class: "form-label" }
const _hoisted_40 = { class: "p-fluid grid mt-2" }
const _hoisted_41 = { class: "field col-12 md:col-6" }
const _hoisted_42 = { class: "p-float-label" }
const _hoisted_43 = { class: "form-label" }
const _hoisted_44 = { class: "field col-12 md:col-6" }
const _hoisted_45 = { class: "p-float-label" }
const _hoisted_46 = { class: "form-label" }
const _hoisted_47 = { class: "field col-12 md:col-6" }
const _hoisted_48 = { class: "p-float-label" }
const _hoisted_49 = { class: "form-label" }
const _hoisted_50 = { class: "field col-12 md:col-6" }
const _hoisted_51 = { class: "p-float-label" }
const _hoisted_52 = { class: "form-label" }
const _hoisted_53 = { class: "field col-12 md:col-6" }
const _hoisted_54 = { class: "p-float-label" }
const _hoisted_55 = { class: "form-label" }
const _hoisted_56 = { class: "grid mt-3" }
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_validation = _resolveComponent("validation")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _createVNode(_component_BlockUI, { blocked: _ctx.isLoading }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.item?.id)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t("route.user_edit")), 1))
                : _createCommentVNode("", true),
              (!_ctx.item?.id)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t("route.user_add")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("form", {
            class: "ml-0 my-4",
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_Fieldset, {
                legend: _ctx.$t('general.access_data')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.username,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid':
                            _ctx.v$.username.$dirty && _ctx.v$.username.$invalid,
                        }]),
                              modelValue: _ctx.username,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                              placeholder: _ctx.$t('user.username')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("user.username")) + "* ", 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.email,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid': _ctx.v$.email.$dirty && _ctx.v$.email.$invalid,
                        }]),
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                              placeholder: _ctx.$t('auth.email')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("auth.email")) + "* ", 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.password,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid':
                            _ctx.v$.password.$dirty && _ctx.v$.password.$invalid,
                        }]),
                              modelValue: _ctx.password,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                              placeholder: _ctx.$t('auth.password')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("auth.password")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["legend"]),
              _createVNode(_component_Fieldset, {
                legend: _ctx.$t('general.user_data'),
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.salutation,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_Dropdown, {
                              style: {"min-width":"250px"},
                              id: "salutation",
                              modelValue: _ctx.salutation,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.salutation) = $event)),
                              options: _ctx.salutations
                            }, null, 8, ["modelValue", "options"]),
                            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("user.salutation")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.lastName,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid':
                            _ctx.v$.lastName.$dirty && _ctx.v$.lastName.$invalid,
                        }]),
                              modelValue: _ctx.lastName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lastName) = $event)),
                              placeholder: _ctx.$t('user.last_name')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("user.last_name")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.firstName,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid':
                            _ctx.v$.firstName.$dirty && _ctx.v$.firstName.$invalid,
                        }]),
                              modelValue: _ctx.firstName,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firstName) = $event)),
                              placeholder: _ctx.$t('user.first_name')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("user.first_name")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.street,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid': _ctx.v$.street.$dirty && _ctx.v$.street.$invalid,
                        }]),
                              modelValue: _ctx.street,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.street) = $event)),
                              placeholder: _ctx.$t('user.street')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("user.street")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_validation, {
                        validations: _ctx.v$.zipCode,
                        "show-errors": true,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_InputText, {
                              class: _normalizeClass(["form-control", {
                          'is-invalid':
                            _ctx.v$.zipCode.$dirty && _ctx.v$.zipCode.$invalid,
                        }]),
                              modelValue: _ctx.zipCode,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.zipCode) = $event)),
                              placeholder: _ctx.$t('user.post_code')
                            }, null, 8, ["modelValue", "placeholder", "class"]),
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("user.post_code")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["validations"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.city,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.city) = $event)),
                          placeholder: _ctx.$t('user.city')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("user.city")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.region,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.region) = $event)),
                          placeholder: _ctx.$t('user.region')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("user.region")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.country,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.country) = $event)),
                          placeholder: _ctx.$t('user.country')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("user.country")), 1)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["legend"]),
              _createVNode(_component_Fieldset, {
                legend: _ctx.$t('general.company_data'),
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.company,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.company) = $event)),
                          placeholder: _ctx.$t('user.company')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("user.company")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.department,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.department) = $event)),
                          placeholder: _ctx.$t('user.department')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("user.department")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.phone,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.phone) = $event)),
                          placeholder: _ctx.$t('user.telephone')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("user.telephone")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.fax,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.fax) = $event)),
                          placeholder: _ctx.$t('user.fax')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("user.fax")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_InputText, {
                          class: "form-control",
                          modelValue: _ctx.webSite,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.webSite) = $event)),
                          placeholder: _ctx.$t('general.website')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("general.website")), 1)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["legend"]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_Button, {
                      label: _ctx.$t('buttons.back'),
                      class: "p-button-text",
                      onClick: _ctx.goBack,
                      icon: "pi pi-arrow-left"
                    }, null, 8, ["label", "onClick"]),
                    _createVNode(_component_Button, {
                      type: "submit",
                      label: _ctx.$t('general.save'),
                      class: "p-button-raised ml-3",
                      icon: "pi pi-save",
                      iconPos: "right"
                    }, null, 8, ["label"])
                  ])
                ])
              ])
            ])
          ], 32)
        ]),
        _: 1
      }, 8, ["blocked"]),
      _createVNode(_component_Spinner, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"])
    ]),
    _: 1
  }))
}